
import { createSlice } from "@reduxjs/toolkit";
import { getCartProducts, cartProductCount } from "../../reduxApi/website/CartProductCount";

import { deleteFromCartApi, updateCartProductApi, clearCartApi } from "../../api/website/Addtocartapi";

const initialState = {
  status: "idle",
  CartCount: 0, // Logged-in cart count
  guestCartCount: 0, // Guest cart count (localStorage)
  CartProducts: [],
  error: null,
};

const CartSlice = createSlice({
  name: "Cart",
  initialState,
  reducers: {
    // Guest cart count logic
    setGuestCartCount: (state, action) => {
      state.guestCartCount = action.payload;
    },
    incrementGuestCartCount: (state) => {
      state.guestCartCount += 1;
    },
    decrementGuestCartCount: (state) => {
      if (state.guestCartCount > 0) {
        state.guestCartCount -= 1;
      }
    },
    resetGuestCartCount: (state) => {
      state.guestCartCount = 0;
    },
     clearCartLocal: (state) => {
    state.CartProducts = [];
    state.CartCount = 0;
  },
  },
  extraReducers: (builder) => {
    builder
      // ✅ Get cart count
      .addCase(cartProductCount.pending, (state) => {
        state.status = "pending";
      })
      .addCase(cartProductCount.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.CartCount = action.payload.data;
      })
      .addCase(cartProductCount.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      // ✅ Get cart products
      .addCase(getCartProducts.pending, (state) => {
        state.status = "pending";
      })
      .addCase(getCartProducts.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.CartProducts = action.payload.data;
        console.log(" state.CartProducts", state.CartProducts)
      })
      .addCase(getCartProducts.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      //   // ✅ Delete product from cart
      //   .addCase(deleteFromCartApi.fulfilled, (state, action) => {
      //     const deletedRowId = action.meta.arg.rowid;
      //     state.CartProducts = state.CartProducts.filter((item) => item.rowid !== deletedRowId);
      //     state.CartCount = Math.max(0, state.CartCount - 1);
      //   })
      .addCase(deleteFromCartApi.fulfilled, (state, action) => {
        const deletedRowId = action.meta.arg.rowid;
        const cartArray = Array.isArray(state.CartProducts) ? state.CartProducts : [];
        state.CartProducts = cartArray.filter(item => item.rowid !== deletedRowId);
        state.CartCount = Math.max(0, state.CartCount - 1);
      })

      .addCase(deleteFromCartApi.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      // ✅ Update cart product
      .addCase(updateCartProductApi.fulfilled, (state, action) => {
        const updatedItem = action.meta.arg;
        state.CartProducts = state.CartProducts.map((item) => (item.rowid === updatedItem.rowid ? { ...item, ...updatedItem } : item));
      })
      .addCase(updateCartProductApi.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      })

      // ✅ Clear entire cart
      .addCase(clearCartApi.fulfilled, (state) => {
        state.CartProducts = [];
        state.CartCount = 0;
      })
      .addCase(clearCartApi.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
      
  },
});

export const { setGuestCartCount, incrementGuestCartCount, decrementGuestCartCount, resetGuestCartCount, clearCartLocal } = CartSlice.actions;

export default CartSlice.reducer;
